<template>
    <v-card
        :class="{
            'card--flex-vertical': true,
            'card--posts': true,
        }"
    >
        <v-card-text
            :class="{
                'card-text--posts': true,
                'text-center': false,
            }"
        >
            <nuxt-link :to="getCustomLocalePath(post)" prefetch>
                <EmbedSanityImage
                    :selectedImage="selectedImage"
                    :alt="fallbackImageAlt(post.sanityThumbnail)"
                    height="400"
                    width="1200"
                    :classes="`align-end`"
                    :img-classes="`card-img--posts`"
                    :image-align="`none`"
                    :crop="imgCrop"
                />
            </nuxt-link>
        </v-card-text>
        <!-- <v-spacer></v-spacer> -->
        <v-card-title
            :class="{
                'card-title--posts': true,
                'text-center': false,
                squeeze: false,
            }"
        >
            <nuxt-link
                :to="getCustomLocalePath(post)"
                class="no-underline nav-a--text2 card"
                prefetch
            >
                <span>{{
                    $i18n.locale ? post.title[$i18n.locale] : post.title.en
                }}</span>
            </nuxt-link>
        </v-card-title>
        <v-card-text>
            {{
                post.seometa &&
                post.seometa.metaDescription &&
                post.seometa.metaDescription[$i18n.locale]
            }}
        </v-card-text>
        <v-card-text v-if="false" class="publishDate">
            {{ post.publishDate }}
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions class="card-actions--featuredPosts">
            <!-- <v-spacer></v-spacer> -->
            <v-btn
                color="primary"
                outlined
                :to="getCustomLocalePath(post)"
                prefetch
                ><TranslatableStringComponent
                    :tstring="{ string: 'readMore' }"
                />
                {{ post._type }}</v-btn
            >
        </v-card-actions>
    </v-card>
</template>
<script>
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'CardSinglePost',
    components: {
        EmbedCloudinary2,
        TranslatableStringComponent,
        EmbedSanityImage,
    },
    props: {
        post: {
            type: Object,
            default: null,
        },
        imgCrop: {
            type: String,
            default: 'fill',
        },
    },
    methods: {
        fallbackImageAlt(thumb) {
            return thumb && thumb.alt
                ? thumb.alt
                : { en: 'c3controls', es: 'c3controls' }
        },
    },
    computed: {
        selectedImage() {
            if (this.post.sanityThumbnail) {
                return this.$i18n.locale === 'es'
                    ? this.post.sanityThumbnail.selectedImageEs ||
                          this.post.sanityThumbnail.selectedImage
                    : this.post.sanityThumbnail.selectedImage
            } else {
                return null
            }
        },
    },
}
</script>
